import React from 'react';
import { Container, Card } from "react-bootstrap";
// import DavePic from "../../images/115488.jpg";


function ExpansionJutsuTwo() {
    return (
        <Container>
            <Card.Text>We have been a team for over 15 years, having fun with our dogs and only using positive training techniques to learn this exciting team sport.</Card.Text>
            <Card.Text>The club is open to anyone interested in teaching their dog the sport of flyball, and all family members are encouraged to participate. Dogs of any age, breed, or experience are welcome to come join the fun.</Card.Text>
            {/* <Card.Text>The Usual Suspects was founded in XXXX by Dave Goldwine. As a dog trainer and longtime flyball dog runner his passion for the sport lead him to xxx. Since then, our team has competed in XXX tournaments under the UFli and NAFA leagues.</Card.Text> */}


        </Container>
    );
};

export default ExpansionJutsuTwo;

//              <Row>
//                 <Col md={6}>
//                     {/* dave pic right */}
//                     <Image src={DavePic}
//                         style={{
//                             width: '100%',
//                             marginLeft: 'auto',
//                             marginRight: 'auto',
//                             display: 'block',
//                             paddingTop: '2vh',
//                             paddingBottom: '2vh'
//                         }} />
//                 </Col>
//                 <Col md={6}>
//                     <Card.Body id="daveDescriptionLeft">
//                         <Card.Text>On June 28, 2019, our founder Dave Goldwine passed away. His spirit
//                             continues to live on in our memories and within his Flyball legacy.</Card.Text>
//                     </Card.Body>
//                 </Col>
//             </Row>
//             <div className="d-flex justify-content-center">
//                 <Badge bg="success" className="text-center" style={{ margin: '10px' }}>Show Less</Badge>
//             </div>